import React from 'react';
import InventoryLogos from '../../screens/PhoneDetailsScreen/InventoryBadges/InventoryBadges';
import Image from '../../UI/Image/Image';
import { isKiosk } from '../../../utils/isKiosk';
import { InventoryStatus } from '../../../types';
import useActiveStore from '../../../hooks/useActiveStore';
import Loader from '../../UI/Loader/Loader';
import {
  InventoryWrapper,
  StartChatButton,
  ReserveButton,
  ValidationError,
  ErrorWrapper,
  LoadingWrapper,
} from './styles';

interface Props {
  inventoryStatus: string | null;
  inventoryLabels: Record<string, any>;
  reserve: () => void;
  variantLabels: Record<string, any>[];
  openChatWidget: (e: any, greeting: string) => Promise<void>;
  errorMessage?: boolean | string;
  apiError: boolean;
  loading: boolean;
}
const VariantCTA = ({
  inventoryStatus,
  inventoryLabels,
  reserve,
  variantLabels,
  openChatWidget,
  errorMessage,
  apiError,
  loading,
}: Props) => {
  const { activeStore } = useActiveStore();
  const isKioskMode = isKiosk();
  // Check if loading or if inventoryStatus is null (so we don't see Add to Basket temporarily)
  if (loading || inventoryStatus == null) {
    return (
      <LoadingWrapper data-testid="variant-cta-loading">
        <Loader className="small m-auto" />
      </LoadingWrapper>
    );
  }
  const isInStock = inventoryStatus !== InventoryStatus.OutOfStock
    && inventoryStatus !== InventoryStatus.NotFound;
  return (
    <>
      {isInStock && (
        <div>
          <InventoryWrapper>
            <InventoryLogos
              activeStore={activeStore}
              inventoryLabels={inventoryLabels}
              apiError={apiError}
              inventoryStatus={inventoryStatus!}
              page="accessoryProductDetail"
            />
          </InventoryWrapper>
          <ReserveButton
            onClick={reserve}
            data-testid="reserve-button"
            data-ga="cta-add to basket-accessories"
          >
            {variantLabels?.[5]?.displayLabel}
          </ReserveButton>
        </div>
      )}
      {!isInStock && !isKioskMode && (
        <StartChatButton
          onClick={openChatWidget}
          data-testid="learn-more-button"
        >
          {variantLabels?.[3]?.displayLabel}
        </StartChatButton>
      )}
      {errorMessage && (
        <ErrorWrapper>
          <Image image={variantLabels?.[6].fieldContent[0]} />
          <ValidationError>{errorMessage}</ValidationError>
        </ErrorWrapper>
      )}
    </>
  );
};

export default VariantCTA;
